export const IMPORT = 'import';
export const EXPORT = 'export';
export const DOMESTIC = 'domestic';
export const RELOAD = 'reload';
export const REPOSITION = 'reposition';
export const INTERMODAL = 'intermodal';

